module.exports = __webpack_public_path__ + "media/images/cardBack-3e4e48775af0f3518cfc104110b5f934.png";